export default "<!-- <app-product-category></app-product-category> -->\r\n<router-outlet></router-outlet>"